module.exports = __webpack_public_path__ + "img/icon-competency.7f7fa877.svg";